<div
  *ngFor="let record of records; trackBy: trackByCorrelationId"
  class="conv-card"
  [class.mobile-card]="isMobile"
  (click)="getChatHistory(record)"
  [class.selected]="record.correlation_id === selectedCard"
>
  <div class="avatar" [style.background]="getChannelColor(record.channel)">
    <i [class]="getChannelIcon(record.channel)"></i>
  </div>
  <div class="card-body">
    <!-- Desktop: fila nombre + tiempo -->
    <div class="card-row-1 d-row">
      <span class="card-name">{{ getDisplayName(record) }}</span>
      <span class="card-time">{{ getRecordDate(record) }}</span>
    </div>
    <!-- Mobile: fila fecha -->
    <div class="card-row-1 m-row">
      <div class="flex-sp"></div>
      <span class="card-time">{{ getRecordDate(record) }}</span>
    </div>
    <!-- Mobile: nombre (segunda fila) -->
    <span class="card-name m-name">{{ getDisplayName(record) }}</span>
    <!-- Mensaje -->
    <div class="card-row-2">
      <span class="card-msg">{{ record.last_message | maxText }}</span>
    </div>
  </div>
</div>
